var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import SignupModalConsents from './SignupModalConsents';
import SignupModalMarketing from './SignupModalMarketing';
import Modal from '../../Components/ComponentModal';
import Message from '../../ComponentMessage';
import T from './Locale';
const SignupModal = ({ name, email, isNewUser = true, partner }) => {
    const [showModal] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [activePage, setActivePage] = useState(1);
    const [user, setUser] = useState({});
    const [errors, setErrors] = useState({});
    useEffect(() => {
        if (!showModal) {
            window.location.href = '/min-side';
        }
    }, [showModal]);
    /**
     * Validate all fields on page and go to next page.
     *
     * @param {object} updatedUser
     */
    const goToSecondPage = (updatedUser) => {
        setUser(updatedUser);
        setActivePage(2);
    };
    /**
     * Save the information.
     */
    const save = (marketingConsent) => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        try {
            const path = `/partner/signup/conditions/${partner.id}?token=${token}${marketingConsent ? '&marketing=1' : ''}`;
            const response = yield axios.post(path, user);
            window.location.href = response.data;
        }
        catch (error) {
            setIsLoading(false);
            if (error.response && error.response.status === 400) {
                setErrors({ save: error.response.data });
            }
            else {
                setErrors({ save: T('partner.modal.errors.save') });
            }
        }
    });
    return (_jsxs("div", { children: [errors.save && (_jsx(Message, { message: errors.save, isSuccessful: false })), showModal && (_jsxs(Modal, Object.assign({ fastRender: true, id: 'sign-up-modal', isWide: true }, { children: [_jsxs("div", Object.assign({ className: 'text-center', "data-behat": 'welcome' }, { children: [_jsx("h1", { dangerouslySetInnerHTML: { __html: T('partner.modal.title', { name }) } }), _jsx("p", { dangerouslySetInnerHTML: { __html: isNewUser ? T(activePage === 1 ? 'partner.modal.description_first' : 'partner.modal.description_second') : T('partner.modal.description_existing') } })] })), _jsx("br", {}), activePage === 1 && (_jsx(SignupModalConsents, { user: user, email: email, goToNextPage: goToSecondPage, isNewUser: isNewUser, partner: partner })), activePage === 2 && (_jsx(SignupModalMarketing, { save: save, isLoading: isLoading }))] })))] }));
};
SignupModal.propTypes = {
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    isNewUser: PropTypes.bool,
    partner: PropTypes.object.isRequired
};
export default SignupModal;
